const NES_TYPE_TO_ICON_NAME = {
    success: 'check-filled',
    informative: 'info-filled',
    warning: 'alert-filled',
    error: 'alert-filled',
    'error-heavy': 'alert-filled',
};
const NES_TYPE_TO_ICON_COLOR = {
    success: 'text-success-contrast',
    informative: 'text-info-contrast',
    warning: 'text-warning-contrast',
    error: 'text-alert-contrast',
    'error-heavy': 'text-light',
};
const NES_TYPE_TO_HEADING_COLOR = {
    success: 'text-success-contrast',
    informative: 'text-info-contrast',
    warning: 'text-warning-contrast',
    error: 'text-alert-contrast',
    'error-heavy': 'text-light',
};

export { NES_TYPE_TO_ICON_NAME as N, NES_TYPE_TO_ICON_COLOR as a, NES_TYPE_TO_HEADING_COLOR as b };
